// extracted by mini-css-extract-plugin
export default {"path":"CouponPath_path__0Oc79","last":"CouponPath_last__J6GUI","first":"CouponPath_first__qKNbV"};